export const PermissionSeparator = {
    PUT: "change_userseparator",
    VIEW: "view_userseparator",
    POST: "add_userseparator",
    DELETE: "delete_userseparator",
    EXPORT: "can_export_userseparator",
};